import React from "react";
import { Controller } from "react-hook-form";
import { FormGroup, Input, Checkbox, Textarea } from "@cofano/cck";
import { Grid } from "@mui/material";
import { Language } from "imports/Utils";

export default ({ control }) => {
	return (
		<React.Fragment>
			<Grid xs={6} item>
				<FormGroup label={Language("LETTER_OF_PROTEST_QUALITY")} labelPlacement="left-center" overflow="hidden">
					<Controller
						name="protestVariables.qualityApplicable"
						control={control}
						render={({ field }) => <Checkbox {...field} checked={field.value} />} />
				</FormGroup>

				<FormGroup label={Language("LETTER_OF_PROTEST_FREEWATER_PRESENCE")} labelPlacement="left-center" overflow="hidden">
					<Controller
						name="protestVariables.freeWaterPresenceApplicable"
						control={control}
						render={({ field }) => <Checkbox {...field} checked={field.value} />} />
				</FormGroup>

				<FormGroup label={Language("LETTER_OF_PROTEST_FREEWATER_CBM")} labelPlacement="left-center" overflow="hidden">
					<Controller
						name="protestVariables.freeWaterCbm"
						control={control}
						render={({ field }) => <Input {...field} />} />
				</FormGroup>

				<FormGroup
					label={(
						<React.Fragment>
							{Language("LETTER_OF_PROTEST_SHORE_TANK")}
							{" "}
							{Language("LETTER_OF_PROTEST_OR")}
							{" "}
							{Language("LETTER_OF_PROTEST_SHIPS_TANK")}
						</React.Fragment>
					)}
					overflow="hidden">
					<div style={{ paddingLeft: 16, paddingTop: 16 }}>
						<div style={{ marginBottom: 8 }}>
							<Controller
								name="protestVariables.shoreTankApplicable"
								control={control}
								render={({ field }) => <Checkbox {...field} checked={field.value} label={Language("LETTER_OF_PROTEST_SHORE_TANK")} />} />
						</div>

						<Controller
							name="protestVariables.shipsTankApplicable"
							control={control}
							render={({ field }) => <Checkbox {...field} checked={field.value} label={Language("LETTER_OF_PROTEST_SHIPS_TANK")} />} />
					</div>
				</FormGroup>
			</Grid>

			<Grid xs={12} item >
				<h3>{Language("LETTER_OF_PROTEST_CONTAMINANTS")}</h3>

				{[ ...Array(5) ].map((_, index) => (
					<Grid key={index} container spacing={2}>
						<Grid xs={4} item>
							<FormGroup label={Language("LETTER_OF_PROTEST_ITEM")} labelPlacement="left-center" overflow="hidden">
								<Controller
									name={`protestVariables.contaminants[${index}].item`}
									control={control}
									render={({ field }) => <Input {...field} />} />
							</FormGroup>
						</Grid>

						<Grid xs={4} item>
							<FormGroup label={Language("LETTER_OF_PROTEST_MEASURED_PPM")} labelPlacement="left-center" overflow="hidden">
								<Controller
									name={`protestVariables.contaminants[${index}].measuredPpm`}
									control={control}
									render={({ field }) => <Input {...field} />} />
							</FormGroup>
						</Grid>

						<Grid xs={4} item>
							<FormGroup label={Language("LETTER_OF_PROTEST_SPEC_PPM")} labelPlacement="left-center" overflow="hidden">
								<Controller
									name={`protestVariables.contaminants[${index}].specPpm`}
									control={control}
									render={({ field }) => <Input {...field} />} />
							</FormGroup>
						</Grid>
					</Grid>
				))}
			</Grid>

			<Grid xs={6} item>
				<FormGroup label={Language("LETTER_OF_PROTEST_QUALITY_CHANGE")} labelPlacement="left-center" overflow="hidden">
					<Controller
						name="protestVariables.qualityChangeApplicable"
						control={control}
						render={({ field }) => <Checkbox {...field} checked={field.value} />} />
				</FormGroup>

				<FormGroup label={Language("LETTER_OF_PROTEST_QUALITY_CHANGE_NOTES")} labelPlacement="left" overflow="hidden">
					<Controller
						name="protestVariables.qualityChangeNotes"
						control={control}
						render={({ field }) => <Textarea {...field} />} />
				</FormGroup>
			</Grid>
		</React.Fragment>
	);
};

